import React from 'react';
import PropTypes from 'prop-types';
import withFavorites from './WithFavorites';
import { humanizeNumber } from '../../../utils/format';

export function CommunitiesListItemComponent({ handleClick, community, showPopulation }) {
  return (
    <div className="communities-list-item" id={community.name}>
      <a
        tabIndex="0"
        onClick={() => { handleClick('communities', community); }}
        className="communities-item__link"
      >
        {community.name}, {community.state}
        {showPopulation &&
          <span className="areas-population-text">
            Population: {humanizeNumber(community.population)}
          </span>
        }
      </a>
    </div>
  );
}

CommunitiesListItemComponent.propTypes = {
  community: PropTypes.shape({
    name: PropTypes.string.isRequired,
    population: PropTypes.number,
  }),
  handleClick: PropTypes.func.isRequired,
  showPopulation: PropTypes.bool,
};

export default withFavorites(CommunitiesListItemComponent);



// WEBPACK FOOTER //
// ./src/components/List/Areas/CommunitiesListItem.js